export default __webpack_public_path__ + "static/media/Foco-Bold.258a3bf1.ttf";